"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

Object.defineProperty(exports, "__esModule", {
  value: true
});

var predictor_js_1 = require("../predictor.js");

var BaseDecoder = /*#__PURE__*/function () {
  function BaseDecoder() {
    (0, _classCallCheck2.default)(this, BaseDecoder);
  }

  (0, _createClass2.default)(BaseDecoder, [{
    key: "decode",
    value: function () {
      var _decode = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(fileDirectory, buffer) {
        var decoded, predictor, isTiled, tileWidth, tileHeight;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.decodeBlock(buffer);

              case 2:
                decoded = _context.sent;
                predictor = fileDirectory.Predictor || 1;

                if (!(predictor !== 1)) {
                  _context.next = 9;
                  break;
                }

                isTiled = !fileDirectory.StripOffsets;
                tileWidth = isTiled ? fileDirectory.TileWidth : fileDirectory.ImageWidth;
                tileHeight = isTiled ? fileDirectory.TileLength : fileDirectory.RowsPerStrip || fileDirectory.ImageLength;
                return _context.abrupt("return", (0, predictor_js_1.applyPredictor)(decoded, predictor, tileWidth, tileHeight, fileDirectory.BitsPerSample, fileDirectory.PlanarConfiguration));

              case 9:
                return _context.abrupt("return", decoded);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function decode(_x, _x2) {
        return _decode.apply(this, arguments);
      }

      return decode;
    }()
  }]);
  return BaseDecoder;
}();

exports.default = BaseDecoder;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7OztBQUFBOztJQUVxQkEsVzs7Ozs7Ozs7NEZBQ25CLGlCQUFhQyxhQUFiLEVBQTRCQyxNQUE1QjtRQUFBO1FBQUE7VUFBQTtZQUFBO2NBQUE7Z0JBQUE7Z0JBQUEsT0FDd0IsS0FBS0MsV0FBTCxDQUFpQkQsTUFBakIsQ0FEeEI7O2NBQUE7Z0JBQ1FFLE9BRFI7Z0JBRVFDLFNBRlIsR0FFb0JKLGFBQWEsQ0FBQ0ssU0FBZCxJQUEyQixDQUYvQzs7Z0JBQUEsTUFHTUQsU0FBUyxLQUFLLENBSHBCO2tCQUFBO2tCQUFBO2dCQUFBOztnQkFJVUUsT0FKVixHQUlvQixDQUFDTixhQUFhLENBQUNPLFlBSm5DO2dCQUtVQyxTQUxWLEdBS3NCRixPQUFPLEdBQUdOLGFBQWEsQ0FBQ1MsU0FBakIsR0FBNkJULGFBQWEsQ0FBQ1UsVUFMeEU7Z0JBTVVDLFVBTlYsR0FNdUJMLE9BQU8sR0FBR04sYUFBYSxDQUFDWSxVQUFqQixHQUN4QlosYUFBYSxDQUFDYSxZQUFkLElBQThCYixhQUFhLENBQUNjLFdBUGxEO2dCQUFBLGlDQVNXLG1DQUNMWCxPQURLLEVBQ0lDLFNBREosRUFDZUksU0FEZixFQUMwQkcsVUFEMUIsRUFDc0NYLGFBQWEsQ0FBQ2UsYUFEcEQsRUFFTGYsYUFBYSxDQUFDZ0IsbUJBRlQsQ0FUWDs7Y0FBQTtnQkFBQSxpQ0FjU2IsT0FkVDs7Y0FBQTtjQUFBO2dCQUFBO1lBQUE7VUFBQTtRQUFBO01BQUEsQzs7Ozs7Ozs7Ozs7O0FBREZjIiwibmFtZXMiOlsiQmFzZURlY29kZXIiLCJmaWxlRGlyZWN0b3J5IiwiYnVmZmVyIiwiZGVjb2RlQmxvY2siLCJkZWNvZGVkIiwicHJlZGljdG9yIiwiUHJlZGljdG9yIiwiaXNUaWxlZCIsIlN0cmlwT2Zmc2V0cyIsInRpbGVXaWR0aCIsIlRpbGVXaWR0aCIsIkltYWdlV2lkdGgiLCJ0aWxlSGVpZ2h0IiwiVGlsZUxlbmd0aCIsIlJvd3NQZXJTdHJpcCIsIkltYWdlTGVuZ3RoIiwiQml0c1BlclNhbXBsZSIsIlBsYW5hckNvbmZpZ3VyYXRpb24iLCJleHBvcnRzIl0sInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL2Rpc3QtbW9kdWxlL2NvbXByZXNzaW9uL2Jhc2VkZWNvZGVyLmpzIl0sInNvdXJjZXNDb250ZW50IjpbbnVsbF19